export const EDIT_CTA_TEXT = "Edit";

export const IRCTC_TEXTS = {
    V1: {
        DELIVERY_LOCATION_TEXT: "Order will be delivered to your seat:",
        MOBILE_NUMBER_TEXT: "You can be contacted on:",
        HEADING_TEXT: "Your Details",
        DELIVERY_LOCATION_SUBTEXT: "",
        MOBILE_NUMBER_SUBTEXT: "",
    },
    V2: {
        DELIVERY_LOCATION_TEXT: "Seat no:",
        MOBILE_NUMBER_TEXT: "Contact:",
        HEADING_TEXT: "",
        DELIVERY_LOCATION_SUBTEXT: "Ensure this is the traveller’s seat no.",
        MOBILE_NUMBER_SUBTEXT: "Ensure this is the traveller’s phone no.",
    },
};

export const IRCTC_DELIVERY_LOCATION_TEXT_V2 = "Delivery on";
export const IRCTC_DELIVERY_LOCATION_TEXT = "Delivery at";
export const DELIVERY_AT_STATION_TEXT = "At {0}";

export const IRCTC_ICONS = {
    V1: {
        PHONE: "/irctc_assets/assets/Group%201000007171.png",
        BERTH: "/irctc_assets/assets/Group%201000007170.png",
        HEADER: "/portal/static-assets/icons/checkout/irctc/delivery_header.png",
    },
    V2: {
        PHONE: "/portal/static-assets/icons/checkout/irctc/phone_rain.png",
        BERTH: "/portal/static-assets/icons/checkout/irctc/bench_rain.png",
        HEADER: "/portal/static-assets/icons/checkout/irctc/delivery_rain.png",
        EDIT_ICON: "/portal/static-assets/icons/checkout/irctc/edit_irctc.png",
    },
};

export const DATA_TESTID = {
    DELIVERY_LOCALTION: "irctc-delivery-location",
    CONTACT_NUMBER: "irctc-contact-number",
    EDIT_DELIVERY_LOCALTION: "irctc-edit-delivery-location",
    EDIT_CONTACT_NUMBER: "irctc-edit-contact-number",
};
